<template>
  <el-dialog
    class="wbench-user-select"
    :visible.sync="visible"
    width="960px"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
  >
    <div class="select-title" slot="title">
      <i class="el-icon-s-custom"></i>
      <span>人员选择</span>
    </div>
    <div class="select-main">
      <div class="title">
        <el-tabs v-model="group" type="card">
          <el-tab-pane label="组织结构" name="depart"></el-tab-pane>
          <el-tab-pane label="最近" name="recent"></el-tab-pane>
          <el-tab-pane label="用户组" name="group"></el-tab-pane>
        </el-tabs>
      </div>
      <table class="box" cellpadding="0" cellspacing="0">
        <tr>
          <td class="lt">
            <component
              :multi-enable="multiEnable"
              v-if="visible"
              ref="userList"
              :is="group"
              :orgId="orgId"
              :checked="checkedList"
              @checkUser="checkUser"
            ></component>
          </td>
          <td class="md"></td>
          <td class="rt">
            <div class="box-item">
              <el-form size="mini">
                <el-form-item>
                  <el-input
                    prefix-icon="el-icon-search"
                    placeholder="请输入搜索内容"
                    v-model="searchText"
                    @input="searchEvt"
                    style="width: 305px"
                  ></el-input>
                  <span @click="clearChecked" class="user-select-delete-all" style="top: 1px"
                    >全部删除</span
                  >
                </el-form-item>
              </el-form>
            </div>
            <div class="user-list">
              <el-checkbox-group v-model="rtCheckList" @change="cancelCheckUser">
                <div v-for="(item, index) in showList" :key="index" class="user-item-full right">
                  <el-checkbox
                    :label="item"
                    :title="item.realName + '---' + item.corpName + item.departName"
                  >
                    <span class="user">{{ item.realName }}</span>
                    <span class="corp">{{ item.corpName }}</span>
                    <div class="clear"></div>
                    <span v-if="item.userDuty" class="user">{{ item.userDuty }}</span>
                    <span class="corp">{{ item.departName }}</span>
                    <div class="clear"></div>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="wbench-button" @click="visible = false">取消</el-button>
      <el-button class="wbench-button" type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getUserListByIds, addRecentUserList, trim } from "./api";
import DepartUserList from "./UserList/DepartUserList";
import RecentUserList from "./UserList/RecentUserList";
import GroupUserList from "./UserList/GroupUserList";
import { getCookie } from "@szgc/plt-core-v2";
import request from "../../api/request";

export default {
  name: "UserSelect",
  components: {
    depart: DepartUserList,
    recent: RecentUserList,
    group: GroupUserList
  },
  props: {
    orgId: {
      type: [String, Number],
      default() {
        return "";
      }
    },
    show: {
      type: Boolean,
      default: false
    },
    multiEnable: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    users: {
      type: [Array, String],
      default: () => []
    }
  },
  watch: {
    show: {
      async handler(newValue) {
        this.rtCheckList = [];
        this.checkedList = [];
        this.showList = [];
        if (newValue === true) {
          this.visible = newValue;
        }
        this.renderCheckedList();
      },
      immediate: true
    },
    visible: {
      handler(newValue) {
        if (newValue === false) {
          this.$emit("update:show", newValue);
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      visible: this.show,
      group: "depart",
      userList: [],
      rtCheckList: [],
      checkedList: [],
      prefix: "",
      searchText: "",
      showList: []
    };
  },
  methods: {
    /*最近人员搜索*/
    searchEvt() {
      const searchText = trim(this.searchText);
      this.showList = this.checkedList.filter((item) => {
        if (searchText === "") {
          return item;
        } else {
          if (item.realName && item.realName.indexOf(searchText) > -1) {
            return item;
          } else if (item.corpName && item.corpName.indexOf(searchText) > -1) {
            return item;
          } else if (item.departName && item.departName.indexOf(searchText) > -1) {
            return item;
          } else if (item.mobile && item.mobile.indexOf(searchText) > -1) {
            return item;
          }
        }
      });
    },
    /*选择/取消人员*/
    checkUser(data) {
      const userList = this.$refs.userList.getUserData();
      if (this.multiEnable) {
        //多选
        userList.map((d) => {
          const index = this.checkedList.findIndex((x) => d.userId === x.userId);
          if (index < 0) {
            this.checkedList.push(d);
          }
        });
      } else {
        this.checkedList = [userList[0]].filter(Boolean);
      }
      let notRows = []; //寻找当前页，但是未被选中的行
      data.data.map((item) => {
        let flag = false;
        userList.map((child) => {
          if (child.userId === item.userId) {
            flag = true;
          }
        });
        if (!flag) {
          notRows.push(item);
        }
      });
      this.checkedList = this.removePoint(this.checkedList, notRows); //删除当前页未被选中行
      this.searchText = "";
      this.searchEvt();
    },
    /*删除数组元素*/
    removePoint(arr1, arr2) {
      for (let i = 0; i < arr2.length; i++) {
        for (let j = 0; j < arr1.length; j++) {
          if (arr2[i].userId === arr1[j].userId) {
            arr1.splice(j, 1);
          }
        }
      }
      return arr1;
    },
    /*右边取消选中*/
    cancelCheckUser() {
      if (this.rtCheckList.length === 0) return;
      const result = [];
      this.checkedList.map((d) => {
        const index = this.rtCheckList.findIndex((x) => x.userId === d.userId);
        if (index < 0) {
          result.push(d);
        }
      });
      this.checkedList = result;
      this.rtCheckList = [];
      this.searchText = "";
      this.searchEvt();
    },
    /*清空已选*/
    clearChecked() {
      this.checkedList = [];
      this.rtCheckList = [];
      this.searchText = "";
      this.searchEvt();
    },
    /**
     * 存储最近选择的用户
     */
    async addRecentUserList(userList) {
      this.prefix = getCookie("plt-api-route") || "";
      try {
        await request({
          url: this.prefix + addRecentUserList(),
          method: "put",
          data: {
            data: userList.map((d) => d.userId)
          }
        });
      } catch (e) {
        this.$message.error(e);
      }
    },
    /*确定*/
    submit() {
      let valueArr = [],
        textArr = [],
        sourceArr = [],
        result = [];
      this.checkedList.map((item) => {
        valueArr.push(item.userId);
        textArr.push(item.realName);
        let source = JSON.parse(JSON.stringify(item));
        sourceArr.push(source);
        result.push({
          realName: item.realName,
          userId: item.userId
        });
      });
      if (this.required) {
        if (sourceArr.length === 0) {
          return this.$message.error("请选择人员");
        }
      }
      this.$emit("user-checked", {
        valueText: sourceArr.length > 0 ? valueArr.join(",") : "",
        text: textArr.join(","),
        source: sourceArr
      });
      this.visible = false;
      if (result.length > 0) {
        this.addRecentUserList(result);
      }
    },
    /*获取并渲染已选用户*/
    async renderCheckedList() {
      if (!this.users) return;
      if (this.users.length === 0) return;
      this.prefix = getCookie("plt-api-route") || "";
      const { success, message, data } = await request({
        url: this.prefix + getUserListByIds(),
        method: "post",
        data: {
          data: this.users
        }
      });
      if (!success) return this.$message.error("获取已选择用户信息失败：" + message);
      if (data && data.length > 0) {
        this.checkedList = data;
        this.searchEvt();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.wbench-user-select {
  .select-title {
    font-size: 16px;
    color: #fff;

    span {
      margin-left: 5px;
    }
  }

  .title {
    height: 40px;
    line-height: 30px;
  }

  .box {
    margin-top: 10px;
    table-layout: fixed;
    width: 100%;

    td {
      height: 450px;
      border: 1px solid #d8d8d8;
      padding: 10px;

      &.md {
        width: 50px;
        height: 100%;
        border: none;
      }

      &.ex {
        width: 45px;
        border: none;
        padding: 0 0 0 7px;
      }

      &.lt {
        padding: 0;
        vertical-align: top;

        .corp-box {
          cursor: pointer;
        }

        .divider {
          height: 40px;
          background-color: #f6f9f9;
          border-top: 1px solid #d8d8d8;
          border-bottom: 1px solid #d8d8d8;
          box-sizing: border-box;
        }

        .depart-box {
          height: calc((100% - 90px) / 2);
          padding: 10px;
          box-sizing: border-box;
          overflow-y: auto;
          overflow-x: hidden;
        }

        .user-box {
          height: calc((100% - 90px) / 2);
          padding: 10px;
          overflow-x: hidden;
          overflow-y: auto;
          box-sizing: border-box;
        }
      }

      &.rt {
        padding: 0;
        vertical-align: top;

        .user-list {
          height: calc(100% - 56px);
          overflow-x: hidden;
          overflow-y: auto;
          box-sizing: border-box;
        }
      }
    }

    .box-item {
      background-color: #f6f9f9;
      padding: 7px 10px;
      height: 45px;
      box-sizing: border-box;
      border-bottom: 1px solid #d8d8d8;
      overflow: hidden;
    }
  }

  button[type="button"] {
    padding: 6px 18px;
  }
}
</style>

<style lang="scss">
.wbench-user-select {
  .el-dialog__header {
    padding: 0 10px;
    height: 45px;
    line-height: 45px;
    background-color: var(--szgc-element-primary);

    .el-dialog__title {
      font-size: 16px;
      color: #fff;
    }
  }

  .el-dialog__headerbtn {
    // top: 10px;
    .el-dialog__close {
      // color: #fff;
    }
  }

  .el-dialog__body {
    padding: 15px;
  }

  .user-item-full {
    padding: 5px 10px 2px;
    overflow: hidden;
    border-bottom: 1px solid #d8d8d8;

    &.right {
      padding-right: 0;

      .el-checkbox {
        width: 100%;

        .el-checkbox__input {
          display: none;
        }
      }
    }

    .el-checkbox {
      width: 100%;

      .el-checkbox__input {
        position: relative;
        top: 3px;
        vertical-align: top;
      }

      .el-checkbox__label {
        display: inline-block;
        width: 90%;
        font-size: 13px;

        &:after {
          display: block;
          width: 0;
          height: 0;
          content: "";
          overflow: hidden;
          clear: both;
        }

        .clear {
          &:after {
            display: block;
            width: 0;
            height: 0;
            content: "";
            overflow: hidden;
            clear: both;
          }
        }

        .user {
          display: inline-block;
          float: left;
        }

        .corp {
          display: inline-block;
          float: right;
          width: calc(100% - 100px);
          text-align: right;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .depart {
          margin-top: 3px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

.user-select-delete-all {
  position: absolute;
  font-size: 12px;
  color: var(--szgc-element-primary);
  z-index: 9;
  right: 0;
  top: 5px;
}
</style>
